import { AdminLink } from '@/components/shared/AdminLink'
import { AdminLoadingText } from '@/components/shared/AdminLoadingText'
import { NO_EXPORT_ATTR } from '@/features/reports/helpers'

import { type EntityPreviewType, useEntityPreview } from './useEntityPreview'

type NamedEntityType = Extract<EntityPreviewType, 'account' | 'carrier'>

type Props = {
  type: NamedEntityType
  _id: string
  to: string
  name?: string
}

export const EntityPreviewLink = ({ type, _id, to, name }: Props) => {
  const { data, isLoading } = useEntityPreview(type, _id, !name)
  const displayName = name || data?.name

  return (
    <div className="flex flex-col font-normal">
      <AdminLoadingText isLoading={isLoading && !name} loadingText={_id}>
        <AdminLink className="text-ellipsis" to={to}>
          {displayName}
        </AdminLink>
      </AdminLoadingText>
      {displayName && <small {...{ [NO_EXPORT_ATTR]: true }}>{_id}</small>}
    </div>
  )
}
